import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import {
  InvestmentPlanSimulationProbabilityRequestDTO,
  InvestmentPlanSimulationProbabilityResponseDTO
} from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class InvestmentPlanSimulationProbabilityRequest extends Request<
  InvestmentPlanSimulationProbabilityRequestDTO,
  InvestmentPlanSimulationProbabilityResponseDTO
> {
  constructor(options?: RequestOptions<InvestmentPlanSimulationProbabilityRequestDTO>) {
    super({
      ...options,
      method: 'POST',
      path: `${options?.version ?? '/v2'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/simulation/probability`,
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

  public execute(): Observable<InvestmentPlanSimulationProbabilityResponseDTO> {
    return super
      .execute()
      .pipe(
        map(
          (response: HttpResponse<InvestmentPlanSimulationProbabilityResponseDTO>) => response.body
        )
      );
  }
}

export function getInvestmentPlanSimulationProbability(
  options?: RequestOptions<InvestmentPlanSimulationProbabilityRequestDTO>
): InvestmentPlanSimulationProbabilityRequest {
  return new InvestmentPlanSimulationProbabilityRequest(options);
}
